import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgmCoreModule } from "@agm/core";
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator/ngx';
import { HttpClient } from '@angular/common/http';



@Component({
  selector: 'app-parking',
  templateUrl: './parking.page.html',
  styleUrls: ['./parking.page.scss'],
})
export class ParkingPage implements OnInit {
	public id: any;
  	public data: object;
	loading: any;
	public searched: any;
	public default_img: any;
	public marker_location: any;
	public lat: number;
	public lon: number;
	public title: string;
	public height: string;
  public parking: number;
  public parking_total: number;
  public marker_color: string;

	constructor( private launchNavigator: LaunchNavigator, private route : ActivatedRoute, private http: HttpClient ) { 
		this.data = null;
		/*this.default_img = '../assets/IconApp.svg';*/
		/*setTimeout(() => {
			this.height = (document.documentElement.clientHeight-150)+"px";
			document.getElementById('map-parent').style.width = "100%";
			document.getElementById('map-parent').style.height = this.height;
		  }, 50);*/
		  this.height = (document.documentElement.clientHeight-150)+"px";
	}

	ngOnInit() {
	this.id = this.route.snapshot.paramMap.get('id');
	this.http.get("https://api.infoparkingamalfi.com/parking/status/"+this.id).subscribe( data => {
		//console.log( data );
		this.title = data[0].name;
		let coords = data[0].coords.split(",");
		//console.log( coords );
		this.lat = coords[0];
		//console.log( this.lat );
		this.lon = coords[1];
		/*this.lat = 40.63401296100814;
		this.lon = 14.6070724484995;*/
		switch( this.id ){
			case "1":
			  this.lat = 40.63401296100814;
			  this.lon = 14.6070724484995;
			break;
			case "2":
			  this.lat = 40.632048534992954;
			  this.lon = 14.597350984345304;
			  
			break;
			case "3":
			  this.lat = 40.63382225966007;
			  this.lon = 14.602734324067702;
			  
			break;
			case "4":
			  this.lat = 40.633406219390324;
			  this.lon = 14.602577565607424;
			break;
		  }
		this.parking_total = data[0].total_spot;
		this.parking = data[0].total_spot - data[0].busy_spot;
		if( this.parking < 0 ){
			this.parking = 0;
		}
		this.marker_color = data[0].color;
		this.marker_location = {
			url: '../assets/img/'+this.marker_color+'.png',
			scaledSize: {
				width: 25,
				height: 25
			}
		}
	});
	//this.parking = parseInt(this.route.snapshot.paramMap.get('parking'));
    //console.log(this.id);
    /*switch( this.id ){
      case "1":
		this.title = "Parcheggio Luna Rossa";
		this.lat = 40.63401296100814;
		this.lon = 14.6070724484995;
		this.parking_total = 172;
		//this.parking = Math.floor(Math.random() * this.parking_total) + 1;
		this.marker_color = this.getMarkerColor( this.parking_total, this.parking_total-this.parking );
		this.marker_location = {
			url: '../assets/img/'+this.marker_color+'.png',
			scaledSize: {
				width: 25,
				height: 25
			}
		};
	  break;
	  case "2":
		this.title = "Parcheggio Berma";
		this.lat = 40.632048534992954;
		this.lon = 14.597350984345304;
		this.parking_total = 110;
		//this.parking = Math.floor(Math.random() * this.parking_total) + 1;
		this.marker_color = this.getMarkerColor( this.parking_total, this.parking_total-this.parking );
		this.marker_location = {
			url: '../assets/img/'+this.marker_color+'.png',
			scaledSize: {
				width: 25,
				height: 25
			}
		};
	  break;
	  case "3":
		this.title = "Area sosta Flavio Gioia II";
		this.lat = 40.63382225966007;
		this.lon = 14.602734324067702;
		this.parking_total = 32;
		//this.parking = Math.floor(Math.random() * this.parking_total) + 1;
		this.marker_color = this.getMarkerColor( this.parking_total, this.parking_total-this.parking );
		this.marker_location = {
			url: '../assets/img/'+this.marker_color+'.png',
			scaledSize: {
				width: 25,
				height: 25
			}
		};
	  break;
	  case "4":
		this.title = "Area di sosta Darsena";
		this.lat = 40.633406219390324;
		this.lon = 14.602577565607424;
		this.parking_total = 25;
		//this.parking = Math.floor(Math.random() * this.parking_total) + 1;
		this.marker_color = this.getMarkerColor( this.parking_total, this.parking_total-this.parking );
		this.marker_location = {
			url: '../assets/img/'+this.marker_color+'.png',
			scaledSize: {
				width: 25,
				height: 25
			}
		};
	  break;
	}*/
	/*setTimeout(() => {
		document.getElementById('map-parent').style.width = "100%";
		document.getElementById('map-parent').style.height = this.height;
	  }, 10);*/
  }

	startNavigation() { 
	//let options;
		let options: LaunchNavigatorOptions = {
			app: this.launchNavigator.APP.GOOGLE_MAPS
		}
		this.launchNavigator.navigate(this.lat+','+this.lon, options)
		.then(
			success => console.log('Launched navigator'),
			error => console.log('Error launching navigator', error)
		);
	}

	ionViewWillEnter(){
		this.ngOnInit();
	}
}
